<template>
  <div class="ChangePasswordComponent">
    <Form
      @submit="changePassword"
      :validation-schema="schema"
      v-slot="{ meta }"
    >
      <TitleComponent class="ChangePasswordComponent__overhead">
        <template v-slot:icon><span class="icon-ico_password"></span></template>
        <template v-slot:content>パスワード設定</template>
      </TitleComponent>
      <CardComponent class="form-changePassword" :width="'960px'" height="auto">
        <p class="form-changePassword-description">
          今後使用するパスワードを設定してください。
        </p>

        <div class="form-changePassword-inputGroups">
          <div class="form-changePassword-inputGroup">
            <InputComponent
              name="oldPassword"
              type="password"
              maxlength="256"
              :validateSteps="validateSteps"
              inputFilter="trimPassword"
              placeholder="現在のパスワードを入力"
            />
          </div>
          <div class="form-changePassword-inputGroup">
            <InputComponent
              name="password"
              type="password"
              maxlength="256"
              :validateSteps="validateSteps"
              inputFilter="trimPassword"
              placeholder="新しいパスワードを入力"
            />
          </div>
          <div class="form-changePassword-inputGroup">
            <InputComponent
              name="passwordConfirmation"
              type="password"
              maxlength="256"
              inputFilter="trimPassword"
              placeholder="新しいパスワードを再入力"
            />
          </div>
        </div>
        <ErrorDetailComponent v-if="errorDetail" :errorDetail="errorDetail" />
        <ButtonComponent
          buttonType="submit"
          :width="'150px'"
          :disabled="!(meta.valid && meta.dirty)"
          >登録
        </ButtonComponent>
      </CardComponent>
    </Form>
  </div>
</template>

<script>
import {
  SPECIAL_STRING,
  VALIDATES,
  MIN_8_CHARACTER,
  STATUS,
} from "@/globals/enums";
import { Form } from "vee-validate";
import LoginService from "@/services/login.service";
import { changePasswordSchema } from "@/validations/schemas/changePasswordSchema";

export default {
  name: "ChangePasswordComponent",
  components: {
    Form,
  },
  data: () => ({
    loginService: new LoginService(),
    validateSteps: [
      {
        message: SPECIAL_STRING.OVER_8_CHARACTERS,
        check: (data) => data.length >= MIN_8_CHARACTER,
      },
      {
        message: SPECIAL_STRING.NUMBER,
        check: (data) => VALIDATES.HAS_NUMBER.test(data),
      },
      {
        message: SPECIAL_STRING.UPPER_DOWNER_CHARACTERS,
        check: (data) => VALIDATES.HAS_DOWNER_CHARACTER.test(data),
      },
    ],
    schema: changePasswordSchema,
    errorDetail: null,
  }),
  methods: {
    async changePassword(value) {
      this.$store.dispatch("global/updateLoadingStatus", true);
      const result = await this.loginService.changePassword(
        value.oldPassword,
        value.password
      );
      this.$store.dispatch("global/updateLoadingStatus", false);
      if (result?.status === STATUS.ERROR && result?.response?.detail) {
        this.errorDetail = result.response.detail;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.ChangePasswordComponent {
  height: 100%;
  display: flex;
  margin-top: var(--default-distance-card);
  justify-content: center;
  &__overhead {
    display: flex;
    gap: 10px;
    align-items: center;
    color: #000;
    .left-content {
      display: block;
    }
    .icon-ico_password {
      &::before {
        color: #000;
      }
    }
  }
  .form {
    &-changePassword {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 30px 0;
      &-description {
        font-size: 14px;
        font-weight: 500;
      }
      &-inputGroups {
        display: flex;
        flex-direction: column;
        gap: 50px;
        padding: 40px 220px 40px;
      }
      &-inputGroup {
        display: flex;
        gap: 30px;
        align-items: center;
        justify-content: space-between;
        &_title {
          font-size: 14px;
          font-weight: normal;
          color: #7c8185;
        }
        .InputComponent {
          margin: 0;
        }
      }
    }
  }
}
@media only screen and (max-width: $mobile-breakpoint) {
  .ChangePasswordComponent {
    height: 100%;
    display: block;
    margin-top: 0;
    .TitleComponent {
      margin-left: 20px;
      width: 300px;
    }
    .v-card {
      width: 100% !important;
      height: 95% !important;
    }
    form {
      height: 100%;
    }
    .form {
      &-changePassword {
        padding-top: 30px;
        &_title {
          font-size: 20px;
          font-weight: 500;
        }
        &-description {
          font-size: 14px;
          font-weight: 500;
          margin: 20px 0 20px;
        }
        &-inputGroups {
          display: flex;
          flex-direction: column;
          gap: 0px;
          padding: 0 20px 40px;
          width: 100%;
        }
        &-inputGroup {
          display: flex;
          gap: 0;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 50px;
          &_title {
            display: none;
          }
          .InputComponent {
            width: 100% !important;
          }
        }
      }
    }
  }
}
</style>
